// src/version.js
import packageJson from '../../../package.json';
export const appVersion = packageJson.version;
export const appName = packageJson.name;